
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/create-password",
      function () {
        return require("private-next-pages/auth/create-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/create-password"])
      });
    }
  